import { injectIntl } from "react-intl";

const MATCH_FILTERS = [
  { value: null, label: "All" },
  { value: true, label: "Matched" },
  { value: false, label: "Unmatched" },
];

const Header = (props) => {
  return (
    <div className={"PageHeader"}>
      <div className={"PageHeaderTitle"}>
        {props.title} Creative
        <span className={"text-[#8185A8]"}> ({props.subtitle})</span>
      </div>
      <div className={"flex gap-3"}>
        <div
          className="flex h-[38px] items-center rounded-lg border border-gray-300 bg-white p-[3px]"
          role="group"
          aria-label="Everflow match"
        >
          {MATCH_FILTERS.map((option) => {
            const selected = props.everflowMatched === option.value;
            return (
              <button
                key={option.label}
                type="button"
                className={`h-[30px] rounded-md px-3 text-[12px] font-semibold ${
                  selected ? "bg-[#F9F5FF] text-[#7E50EA]" : "text-[#8185A8]"
                }`}
                style={{ fontFamily: "Inter, sans-serif" }}
                aria-pressed={selected}
                onClick={() => props.onEverflowMatchedChange(option.value)}
              >
                {option.label}
              </button>
            );
          })}
        </div>
        <div className="relative flex items-center">
          <span className="absolute left-3">
            <img
              alt={"Logo"}
              src={"/media/icons/searchIcon.svg"}
              className={"h-[17px] w-[17px]"}
            />
          </span>
          <input
            type="text"
            placeholder="Search"
            value={props.search}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none"
            onChange={(e) => props.setSearch(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(Header);
